import axiosInstance from 'services/axiosMiddleware';

export async function createPranayamaReport(reportData) {
  console.log('reportData', reportData);
  try {
    const response = await axiosInstance.post('pranayamma-report/create-Report', reportData);
    return response.data;
  } catch (error) {
    console.error('Error adding report data:', error);
    throw error;
  }
}
